import type { DomainSpecificConfig } from '../types';

const config: DomainSpecificConfig = {
  domains: [/^student\.magicschool\.ai/, /^student-magicschool-ai.translate.goog/],
  domainType: 'student',
};

export default config;
